module.exports = __webpack_public_path__ + "static/logo-6af726a921ddbb93ff5316a745f60044.png";